import { __rest } from "tslib";
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import { FormControlLabel, Checkbox as MUICheckbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@websky/core/src/theme';
import Tooltip from '../../../../../../core/src/BaseComponents/Tooltip';
let lastVisibleError = '';
const Checkbox = (_a) => {
    var { label, name } = _a, props = __rest(_a, ["label", "name"]);
    const { PassengersToolbar: css } = useTheme('Checkout');
    const { t } = useTranslation('Checkout');
    const { input, meta } = useField(name, {
        type: 'checkbox',
        initialValue: false,
        validate: value => {
            if (!value) {
                return t('Please, read the rules of service and accept it');
            }
            return undefined;
        }
    });
    useEffect(() => {
        // safari bug, when checkbox onBlur didn't fired
        // and form didn't update it's state
        input.onBlur();
    }, [input.value]);
    if (meta.error) {
        lastVisibleError = meta.error;
    }
    return (React.createElement(FormControlLabel, Object.assign({ name: name, classes: {
            root: css.root,
            label: css.label
        }, control: React.createElement(Tooltip, { open: meta.submitFailed && !input.value, title: lastVisibleError, placement: "top-start" },
            React.createElement(MUICheckbox, { color: "primary", classes: {
                    colorPrimary: css.checkbox,
                    checked: css.checkbox_checked
                }, checked: input.checked, inputProps: Object.assign({}, input) })), label: React.createElement("span", { dangerouslySetInnerHTML: {
                __html: label
            } }) }, props)));
};
export default Checkbox;
